module.exports = __webpack_public_path__ + "img/qr.cbad6514.svg";